<template>
  <div class="thunder-overlayer">
    <div class="t-header">
      <span>闪电产品详情信息</span>
    </div>
    <div class="t-info">
      <div class="t-item">
        <span>位置：</span>
        <span>{{ thunderData.lon }}N / {{ thunderData.lat }}E</span>
      </div>
      <div class="t-item">
        <span>时间：</span>
        <span>{{
          $moment(thunderData.crttime).format("YYYY-MM-DD HH:mm")
        }}</span>
      </div>
      <div class="t-item">
        <span>电流：</span>
        <span>{{ thunderData.intensity }}</span>
      </div>
    </div>
    <span class="trangle"></span>
  </div>
</template>

<script>
export default {
  props: ["thunderData"],
};
</script>

<style lang="less" scoped>
.thunder-overlayer {
  position: fixed;
  top: 0px;
  width: 14.58vw;
  background: #25324d;
  box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5);
  border-radius: 12px;
  opacity: 0.7;
  border: 1px solid;
  // box-shadow: 0vw 0vw 0.47vw 0vw rgba(184, 184, 184, 0.5);
  .t-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1.04vw;
    font-size: 0.73vw;
    color: white;
    height: 2.71vw;
    background: #15324d;
    border-radius: 0.63vw 0.63vw 0vw 0vw;
    font-size: 0.94vw;
    font-weight: 500;
    color: #81c3ff;
    line-height: 1.3vw;
  }
  .t-info {
    .t-item {
      padding: 0.26vw 0vw;
      font-size: 0.68vw;
      span:nth-child(1) {
        display: inline-block;
        width: 5.21vw;
        padding: 0;
        text-align: right;
        font-size: 0.83vw;
        color: #fff;
        line-height: 1.45vw;
      }
      span:nth-child(2) {
        font-size: 0.83vw;
        color: #fff;
        line-height: 1.45vw;
      }
    }
  }
  .trangle {
    position: absolute;
    left: 50%;
    bottom: 0%;
    transform: translate(-50%, 100%);
    border: 0.52vw solid #25324d;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  .el-icon-close {
    color: #333;
    padding-right: 1.04vw;
    cursor: pointer;
  }
}
</style>
